import React from 'react';
import TemplateOne from 'gatsby-core-theme/src/components/molecules/header/variants/operator/template-one-two';
import ReviewCredits from 'gatsby-matrix-theme/src/components/atoms/review-credits';

export default (props) => {
  const { page } = props;

  return (
    <>
      <TemplateOne {...props} hasVariableComponent ribbons={[]} />
      <ReviewCredits
        authors={page?.allAuthors ? page?.allAuthors : page?.author_id && [page?.author]}
        reviewer={page.reviewer_id && page?.reviewer}
        date={page?.date}
        readingTime={page.reading_time}
        hasAuthorBox={page?.author_id}
      />
      {page.description && (
        <div
          style={{ padding: '40px 20px' }}
          dangerouslySetInnerHTML={{ __html: page.description }}
        />
      )}
    </>
  );
};
